import { GetterTree } from "vuex";
import { ConfigState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<ConfigState, RootState> = {
	token(state): string {
		return state.token;
	},
	user(state): string {
		return state.user;
	},
	apiroot(state): string {
		return state.apiroot;
	},
	accountid(state): number {
		return state.accountid;
	},
	currentid(state): number {
		return state.currentid;
	},
	thumburl(state): string {
		return state.thumburl;
	},
	store(state): string {
		return state.store;
	}
};
